import { render, staticRenderFns } from "./SetElement.vue?vue&type=template&id=b4089b7c&lang=pug&"
import script from "./SetElement.vue?vue&type=script&lang=js&"
export * from "./SetElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports